// extracted by mini-css-extract-plugin
export default {"boxes":"otpBoxInput_boxes__0q04j","box":"otpBoxInput_box__rXnud"};